module.exports = __webpack_public_path__ + "static/img/game-logo-ws168.b4e618d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-ws168.png
// module id = ZcXL
// module chunks = 0 1 2 3 4 5 6